<div class="simple-dialog-container">
  <i [mat-dialog-close] class="fas fa-times close-icon"></i>
  <div class="image-container">
    <img src="{{ this.data?.url }}" alt="zoom" />
  </div>
</div>
